export default __webpack_public_path__ + "static/media/brownies.da8ed413.jpg";